// 9fbef606107a605d69c0edbcd8029e5d
import {
  BIRTHDAY_PRODUCT_LISTING__REDUCER_KEY,
  RECOMMENDATIONS_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';

/**
 * Selector function to retur redux getBirthdayModuleHp
 * @param { object } state reduxStore state
 */
export const getBirthdayProductListing = (state) =>
  state && state?.[BIRTHDAY_PRODUCT_LISTING__REDUCER_KEY];
export const getDrawerSet = createSelector(
  getBirthdayProductListing,
  (state) => state && state?.get('isModalOpen')
);

export const getCategoryURL = (state, name) => {
  const { navigationData = [] } = state?.Navigation;
  for (let i = 0; i < navigationData?.length; i += 1) {
    if (name?.toLowerCase() === navigationData?.[i]?.categoryContent?.name?.toLowerCase()) {
      return {
        toPath: navigationData?.[i]?.categoryContent?.url,
        asPath: navigationData?.[i]?.categoryContent?.url?.replace('?cid=', '/'),
      };
    }
  }
  return {
    toPath: '/us/home',
    asPath: '/us/home',
  };
};

export const getBirthdayRecommendationData = (state, reduxKey = 'BirthDayModule') => {
  const recommendation = state && state?.[RECOMMENDATIONS_REDUCER_KEY];
  return recommendation && recommendation?.get(reduxKey) && recommendation?.get(reduxKey);
};
